

/* ==========================================

   TIMI ICON SEARCH v3.3

   Smart Search + Popular + All + Zepto Tags + Instant Visibility Repair

   Features:

   - Search all Zepto icon swatches

   - Expanded TIMI search synonyms

   - Search native category tags

   - Support multi-word searches

   - Popular and All browsing tabs

   - Original Zepto category filtering

   - Prevent duplicate buttons and listeners

   - Supports Icon 1, Icon 2 and Icon 3

   - Preserves original backend icon IDs

   - Preserves artwork thumbnails

   \========================================== */

(() => {

  'use strict';

  if (window.__timiDynamicIconSearchV3) return;

  window.__timiDynamicIconSearchV3 = true;

  
const FIELD_SELECTOR = [
  '.pplr-wrapper.pplr-icon-1',
  '.pplr-wrapper.pplr-icon-2',
  '.pplr-wrapper.pplr-icon-3',
  '.pplr-wrapper.pplr-icon-4',
  '.pplr-wrapper.pplr-icon-5'
].join(', ');


  const SWATCH_SELECTOR =

    '.pplr-swatch-element.pplrimage[data-val]';

  /* Original 13 featured icons */

  const POPULAR = new Set([

    'yarn-ball-cozy-sewing-set',

    'needle-thread-sewing-theme',

    'airplane-pastel-theme',

    'balloon-dog-EclecticRetro',

    'cherries-pink-summer',

    'coffee-cup-reading-theme',

    'cozy-socks-cozy-sewing-set',

    'football-sports-balls',

    'heart-button-sewing-theme',

    'open-book-reading-theme',

    'safety-pin-sewing-theme',

    'sparkle-stars-pastel-theme',

    'yarn-ball-knitting-needles-mom-hobbies'

  ]);

  const states = new WeakMap();

  /* Normalize search terms */

  const norm = value =>

    String(value || '')

      .toLowerCase()

      .normalize('NFKD')

      .replace(/[\u0300-\u036f]/g, '')

      .replace(/[-_+&]/g, ' ')

      .replace(/\s+/g, ' ')

      .trim();

  /* ==========================================

     TIMI SMART SEARCH DICTIONARY

     \========================================== */

  const synonyms = {

    /* Fiber Arts */

    crochet: [

      'crochet', 'yarn', 'hook', 'stitch', 'knit'

    ],

    knitting: [

      'knit', 'yarn', 'needle', 'sweater', 'stitch'

    ],

    knitter: [

      'knit', 'yarn', 'needle', 'sweater'

    ],

    crocheter: [

      'crochet', 'yarn', 'hook', 'stitch'

    ],

    fiber: [

      'fiber', 'yarn', 'knit', 'crochet',

      'sewing', 'stitch', 'embroidery'

    ],

    maker: [

      'yarn', 'knit', 'crochet',

      'sew', 'stitch', 'craft'

    ],

    craft: [

      'craft', 'yarn', 'knit',

      'crochet', 'sew', 'embroidery'

    ],

    crafting: [

      'craft', 'yarn', 'knit',

      'crochet', 'sew', 'embroidery'

    ],

    embroidery: [

      'embroider', 'thread', 'needle',

      'sewing', 'stitch', 'hoop'

    ],

    sewing: [

      'sew', 'stitch', 'thread',

      'needle', 'scissor', 'pincushion'

    ],

    wip: [

      'yarn', 'knit', 'crochet',

      'stitch', 'project'

    ],

    /* Cozy / Books / Seasons */

    cozy: [

      'cozy', 'coffee', 'book',

      'sweater', 'sock', 'candle', 'knit'

    ],

    fall: [

      'fall', 'autumn', 'pumpkin',

      'leaf', 'sweater', 'cozy'

    ],

    autumn: [

      'autumn', 'fall', 'pumpkin',

      'leaf', 'sweater'

    ],

    winter: [

      'winter', 'snow', 'snowflake',

      'mitten', 'sweater', 'sock'

    ],

    bookish: [

      'book', 'reading', 'glasses'

    ],

    reading: [

      'book', 'reading', 'glasses'

    ],

    'book lover': [

      'book', 'reading', 'glasses'

    ],

    books: [

      'book', 'reading'

    ],

    /* Coquette / Aesthetic */

    cute: [

      'bow', 'heart', 'cherr', 'flower',

      'ribbon', 'coquette', 'pastel'

    ],

    girly: [

      'bow', 'ribbon', 'heart',

      'cherr', 'pink', 'coquette', 'lipstick'

    ],

    coquette: [

      'bow', 'ribbon', 'heart',

      'cherr', 'coquette', 'lace'

    ],

    aesthetic: [

      'bow', 'ribbon', 'heart',

      'cherr', 'coquette', 'retro', 'y2k'

    ],

    bows: [

      'bow', 'ribbon'

    ],

    hearts: [

      'heart', 'love'

    ],

    valentine: [

      'heart', 'love', 'bow', 'rose'

    ],

    beauty: [

      'lipstick', 'makeup', 'perfume', 'mirror'

    ],

    /* Food & Drink */

    food: [

      'food', 'fruit', 'pizza',

      'pasta', 'cake', 'bread', 'snack'

    ],

    drinks: [

      'drink', 'coffee', 'matcha',

      'tea', 'cocktail', 'wine', 'latte'

    ],

    coffee: [

      'coffee', 'latte', 'espresso', 'cafe', 'cup'

    ],

    matcha: [

      'matcha', 'tea', 'cup'

    ],

    cocktails: [

      'cocktail', 'martini', 'wine', 'drink'

    ],

    fruit: [

      'fruit', 'cherr', 'berry',

      'lemon', 'strawberry', 'peach'

    ],

    /* Nature */

    floral: [

      'flower', 'floral', 'daisy',

      'tulip', 'rose', 'hibiscus'

    ],

    flowers: [

      'flower', 'floral', 'daisy',

      'tulip', 'rose', 'hibiscus'

    ],

    nature: [

      'nature', 'flower', 'plant',

      'leaf', 'tree', 'butterfly', 'mushroom'

    ],

    garden: [

      'flower', 'plant', 'leaf',

      'garden', 'daisy', 'tulip'

    ],

    animals: [

      'animal', 'dog', 'cat',

      'butterfly', 'bird', 'bunny'

    ],

    pets: [

      'pet', 'dog', 'cat', 'puppy', 'kitten'

    ],

    dog: [

      'dog', 'puppy', 'poodle'

    ],

    cat: [

      'cat', 'kitten', 'kitty'

    ],

    /* Western */

    western: [

      'western', 'rodeo', 'cowboy',

      'cowgirl', 'boot', 'bandana'

    ],

    cowgirl: [

      'cowgirl', 'cowboy', 'western',

      'boot', 'rodeo'

    ],

    cowboy: [

      'cowboy', 'cowgirl', 'western',

      'boot', 'rodeo'

    ],

    rodeo: [

      'rodeo', 'western', 'cowboy', 'boot'

    ],

    /* Lucky / Celestial */

    lucky: [

      'luck', 'clover', 'horseshoe',

      'dice', '777', 'charm'

    ],

    luck: [

      'luck', 'clover', 'horseshoe', 'dice', '777'

    ],

    celestial: [

      'celestial', 'zodiac', 'moon',

      'star', 'sun', 'witchy'

    ],

    witchy: [

      'witch', 'moon', 'star',

      'crystal', 'spider', 'zodiac'

    ],

    astrology: [

      'zodiac', 'moon', 'star', 'astrology'

    ],

    horoscope: [

      'zodiac', 'aries', 'taurus',

      'gemini', 'cancer', 'leo',

      'virgo', 'libra', 'scorpio',

      'sagittarius', 'capricorn',

      'aquarius', 'pisces'

    ],

    /* Retro / Y2K */

    retro: [

      'retro', 'vintage', 'disco',

      'y2k', 'cassette', 'vinyl'

    ],

    vintage: [

      'vintage', 'retro', 'disco',

      'vinyl', 'camera'

    ],

    y2k: [

      'y2k', 'retro', '2000',

      'edgy', 'glasses'

    ],

    nostalgia: [

      'retro', 'vintage', 'disco',

      'cassette', 'vinyl'

    ],

    /* Sports / Games */

    sports: [

      'sport', 'football', 'basketball',

      'baseball', 'soccer', 'tennis', 'golf'

    ],

    gameday: [

      'sport', 'football', 'baseball', 'basketball'

    ],

    games: [

      'game', 'casino', 'dice',

      'billiard', 'cards', '777'

    ],

    casino: [

      'casino', 'dice', 'billiard', 'cards', '777', 'ace'

    ],

    /* Travel / Summer */

    travel: [

      'travel', 'airplane', 'plane',

      'passport', 'suitcase', 'beach'

    ],

    vacation: [

      'travel', 'airplane', 'beach',

      'summer', 'suitcase'

    ],

    beach: [

      'beach', 'shell', 'sun',

      'starfish', 'lobster', 'ocean'

    ],

    summer: [

      'summer', 'sun', 'beach',

      'shell', 'lemon', 'lobster'

    ],

    coastal: [

      'beach', 'shell', 'ocean',

      'lobster', 'starfish'

    ],

    italy: [

      'italy', 'italian', 'dolce',

      'pasta', 'lemon', 'summer'

    ],

    /* School / Family / Events */

    teacher: [

      'school', 'teacher', 'pencil',

      'apple', 'book', 'crayon'

    ],

    school: [

      'school', 'apple', 'pencil',

      'backpack', 'book', 'abc'

    ],

    mom: [

      'mom', 'mama', 'mother'

    ],

    wedding: [

      'wedding', 'bride', 'ring',

      'love', 'heart'

    ]

  };

  /* ==========================================

     SEARCH ENGINE

     \========================================== */

  function getSwatches(state) {

    return Array.from(

      state.grid.querySelectorAll(SWATCH_SELECTOR)

    );

  }

  function searchMatches(el, query) {

    /* Search original icon IDs and category tags */

    const haystack = norm([

      el.getAttribute('data-val'),

      el.getAttribute('data-tag')

    ].filter(Boolean).join(' '));

    const cleaned = norm(query);

    if (!cleaned) return true;

    /* Recognize phrases like "book lover" */

    const terms = synonyms[cleaned]

      ? [cleaned]

      : cleaned.split(' ').filter(Boolean);

    return terms.every(term => {

      const alternatives =

        synonyms[term] || [term];

      return alternatives.some(word =>

        haystack.includes(norm(word))

      );

    });

  }

  /* ==========================================

     PRESERVE ZEPTO STYLES

     \========================================== */

  function capture(state, el) {

    if (state.original.has(el)) return;

    state.original.set(el, {

      display: el.style.getPropertyValue('display'),

      displayPriority:

        el.style.getPropertyPriority('display'),

      background:

        el.style.getPropertyValue('background-image'),

      backgroundPriority:

        el.style.getPropertyPriority('background-image')

    });

  }

  function resetOverrides(state) {

    state.original.forEach((props, el) => {

      if (!el.isConnected) return;

      if (props.display) {

        el.style.setProperty(

          'display',

          props.display,

          props.displayPriority

        );

      } else {

        el.style.removeProperty('display');

      }

      if (props.background) {

        el.style.setProperty(

          'background-image',

          props.background,

          props.backgroundPriority

        );

      } else {

        el.style.removeProperty('background-image');

      }

    });

    state.original.clear();

  }

  /* ==========================================

     ARTWORK THUMBNAILS

     \========================================== */

  function setArtwork(el) {

    const image = el.getAttribute('data-image');

    if (image && /^https:\/\//i.test(image)) {

      const artwork = `url("${image.replace(/"/g, '%22')}")`;

      if (
        el.style.getPropertyValue('background-image') !== artwork ||
        el.style.getPropertyPriority('background-image') !== 'important'
      ) {
        el.style.setProperty('background-image', artwork, 'important');
      }

    }

  }

  /* ==========================================

     BUTTON STATES

     \========================================== */

  function updateControls(state) {

    state.toolbar.classList.toggle(

      'timi-mode-custom',

      state.mode !== 'native'

    );

    state.buttons.forEach(button => {

      const active =

        button.dataset.timiMode === state.mode;

      button.classList.toggle(

        'is-active',

        active

      );

      button.setAttribute(

        'aria-pressed',

        String(active)

      );

    });

    state.field.classList.toggle(

      'timi-browse-custom',

      state.mode !== 'native'

    );

  }

  /* ==========================================

     RENDER ICONS

     \========================================== */

  function render(state) {

    const query = state.input.value.trim();

    const mode = query

      ? 'search'

      : state.mode;

    updateControls(state);

    /* Native Zepto category selected */

    if (!query && mode === 'native') {

      resetOverrides(state);

      state.status.textContent = '';

      state.status.hidden = true;

      return;

    }

    let count = 0;

    getSwatches(state).forEach(el => {

      capture(state, el);

      let show = false;

      if (mode === 'search') {

        show = searchMatches(el, query);

      } else if (mode === 'all') {

        show = true;

      } else if (mode === 'popular') {

        show = POPULAR.has(

          el.getAttribute('data-val')

        );

      }

      const expectedDisplay = show ? 'block' : 'none';

      if (
        el.style.getPropertyValue('display') !== expectedDisplay ||
        el.style.getPropertyPriority('display') !== 'important'
      ) {
        el.style.setProperty('display', expectedDisplay, 'important');
      }

      if (show) {

        count++;

        setArtwork(el);

      }

    });

    state.status.hidden = false;

    if (query) {

      state.status.textContent =

        `${count} icon${count === 1 ? '' : 's'} found`;

    } else if (mode === 'popular') {

      state.status.textContent =

        `${count} featured icons`;

    } else {

      state.status.textContent =

        `${count} icons`;

    }

  }

  /* ==========================================

     DUPLICATE PREVENTION

     \========================================== */

  function removeDuplicateControls(field) {

    field.querySelectorAll(

      '.timi-native-search, .timi-special-tabs'

    ).forEach(element => {

      element.remove();

    });

  }

  function cleanup(state) {

    if (!state) return;

    resetOverrides(state);

    if (state.controller) {

      state.controller.abort();

    }

    state.toolbar?.remove();

    state.tabBar?.remove();

    state.field.classList.remove(

      'timi-browse-custom'

    );

  }

  /* ==========================================

     INITIALIZE EACH ICON FIELD

     \========================================== */

  function setup(field) {

    const grid = field.querySelector(

      '.pplr_thumb_image.pplr-swatch-main'

    );

    if (!grid || !grid.querySelector(SWATCH_SELECTOR)) {

      return;

    }

    const existing = states.get(field);

    /* Already initialized */

    if (

      existing &&

      existing.grid === grid &&

      existing.toolbar.isConnected &&

      existing.tabBar.isConnected

    ) {

      /* Remove orphaned duplicate search bars */

      field.querySelectorAll(

        '.timi-native-search'

      ).forEach(el => {

        if (el !== existing.toolbar) el.remove();

      });

      /* Remove orphaned duplicate buttons */

      field.querySelectorAll(

        '.timi-special-tabs'

      ).forEach(el => {

        if (el !== existing.tabBar) el.remove();

      });

      return;

    }

    /* Preserve mode and query across Zepto rebuilds */

    const previousMode = existing

      ? existing.mode

      : 'popular';

    const previousQuery = existing

      ? existing.input.value

      : '';

    cleanup(existing);

    removeDuplicateControls(field);

    const controller = new AbortController();

    /* Search input */

    const toolbar = document.createElement('div');

    toolbar.className = 'timi-native-search';

    const label = document.createElement('label');

    label.className = 'timi-native-search-label';

    label.textContent = 'Search icons';

    const input = document.createElement('input');

    input.className = 'timi-native-search-input';

    input.type = 'search';

    input.placeholder = 'Search yarn, coffee, heart...';

    input.autocomplete = 'off';

    input.setAttribute(

      'aria-label',

      'Search embroidery icons'

    );

    input.value = previousQuery;

    const status = document.createElement('div');

    status.className = 'timi-native-search-status';

    status.setAttribute(

      'aria-live',

      'polite'

    );

    toolbar.append(label, input, status);

    /* Popular / All buttons */

    const tabBar = document.createElement('div');

    tabBar.className = 'timi-special-tabs';

    const buttons = [];

    [

      ['popular', 'Popular'],

      ['all', 'All']

    ].forEach(([mode, text]) => {

      const button = document.createElement('button');

      button.type = 'button';

      button.className = 'timi-special-tab';

      button.dataset.timiMode = mode;

      button.textContent = text;

      tabBar.appendChild(button);

      buttons.push(button);

    });

    /* Insert controls before Zepto categories */

    const category = field.querySelector(

      '.pplr-selecter-item'

    );

    const categoryContainer =

      category?.parentElement;

    if (

      categoryContainer &&

      grid.contains(categoryContainer)

    ) {

      categoryContainer.before(toolbar);

      categoryContainer.before(tabBar);

    } else {

      grid.prepend(tabBar);

      grid.prepend(toolbar);

    }

    /* Store state */

    const state = {

      field,

      grid,

      toolbar,

      input,

      status,

      buttons,

      tabBar,

      controller,

      original: new Map(),

      mode: previousMode

    };

    states.set(field, state);

    /* Search as customer types */

    input.addEventListener(

      'input',

      () => render(state),

      { signal: controller.signal }

    );

    /* Popular / All clicks */

    tabBar.addEventListener(

      'click',

      event => {

        const button = event.target.closest(

          '.timi-special-tab'

        );

        if (!button) return;

        state.input.value = '';

        state.mode = button.dataset.timiMode;

        render(state);

      },

      { signal: controller.signal }

    );

    /* Native Zepto category clicks */

    field.addEventListener(

      'click',

      event => {

        if (!event.target.closest(

          '.pplr-selecter-item'

        )) {

          return;

        }

        state.input.value = '';

        state.mode = 'native';

        resetOverrides(state);

        updateControls(state);

        state.status.textContent = '';

        state.status.hidden = true;

        /* Allow Zepto's native click handler to run */

      },

      {

        capture: true,

        signal: controller.signal

      }

    );

    /*
      Zepto can change individual swatches' inline display
      styles when an image is selected. Restore the current
      TIMI browse filter AFTER Zepto finishes its updates.
      This does not change Zepto values or selected icons.
    */
    // Zepto sometimes hides most popular choices when a swatch is clicked.
    // Restore the current browse mode in the very next microtask and whenever
    // Zepto changes an icon's inline visibility. No delayed one-second repaint.
    let repairQueued = false;

    function repairVisibility() {
      if (repairQueued) return;
      repairQueued = true;
      queueMicrotask(() => {
        repairQueued = false;
        if (states.get(field) !== state || !state.toolbar.isConnected) return;
        if (state.mode === 'native' && !state.input.value.trim()) return;
        render(state);
      });
    }

    const visibilityObserver = new MutationObserver(records => {
      const needsRepair = records.some(record => {
        if (record.type !== 'attributes' || record.attributeName !== 'style') return false;
        const el = record.target;
        if (!el.matches?.(SWATCH_SELECTOR) || !state.grid.contains(el)) return false;
        if (state.mode === 'native' && !state.input.value.trim()) return false;
        const query = state.input.value.trim();
        const show = query ? searchMatches(el, query)
          : state.mode === 'all' ? true
          : state.mode === 'popular' ? POPULAR.has(el.getAttribute('data-val'))
          : false;
        const expected = show ? 'block' : 'none';
        return el.style.getPropertyValue('display') !== expected ||
          el.style.getPropertyPriority('display') !== 'important';
      });
      if (needsRepair) repairVisibility();
    });

    visibilityObserver.observe(state.grid, {
      subtree: true,
      attributes: true,
      attributeFilter: ['style']
    });

    controller.signal.addEventListener('abort', () => {
      visibilityObserver.disconnect();
    }, { once: true });

    field.addEventListener('click', event => {
      const swatch = event.target.closest(
        '.pplr-swatch-element.pplrimage[data-val]:not(.pplr_deselect)'
      );
      if (swatch && field.contains(swatch)) repairVisibility();
    }, { signal: controller.signal });

    /* Initial render */

    render(state);

  }

  /* ==========================================

     INITIALIZE ICON 1, 2 AND 3

     \========================================== */

  function init() {

    document.querySelectorAll(

      FIELD_SELECTOR

    ).forEach(setup);

  }

  function start() {

    init();

    let pending = false;

    /* Watch for Zepto rebuilding fields */

    const observer = new MutationObserver(records => {

      const changed = records.some(

        record => record.type === 'childList'

      );

      if (!changed || pending) return;

      pending = true;

      requestAnimationFrame(() => {

        pending = false;

        init();

      });

    });

    observer.observe(document.body, {

      childList: true,

      subtree: true

    });

  }

  if (document.readyState === 'loading') {

    document.addEventListener(

      'DOMContentLoaded',

      start,

      { once: true }

    );

  } else {

    start();

  }

})();
